import React, { useContext, useEffect, useState } from 'react'

export const MesCmp = ({ addMes }) => {
  const [mes, setMes] = useState('')

  function handlerSeleccion(event) {
   
    setMes(event.target.value)
  }

  function handlerContinuar(mes) {
     addMes(mes)
   }


  return (
    <div >
      <h1 className="text-2xl font-bold mb-10">En que mes desea su sesión?</h1>
      <div className="flex flex-col items-center">
        <select className="select select-secondary w-full max-w-xs" onChange={handlerSeleccion}>
          <option disabled selected>Seleccione el mes</option>
          <option value="Enero">Enero</option>  
          <option value="Febrero">Febrero</option>
          <option value="Marzo">Marzo</option>
          <option value="Abril">Abril</option>
          <option value="Mayo">Mayo</option>
          <option value="Junio">Junio</option>
          <option value="Julio">Julio</option>
          <option value="Agosto">Agosto</option>
          <option value="Septiembre">Septiembre</option>
          <option value="Octubre">Octubre</option>
          <option value="Noviembre">Noviembre</option>
          <option value="Diciembre">Diciembre</option>
        </select>

        <button className="btn btn-primary mt-5" onClick={()=>handlerContinuar(mes)}>Continuar</button>
      </div>
    </div>
  )
}